var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-bar"},[(!_vm.hideLegend)?_c('ui-chart-legend',{attrs:{"items":_vm.legend}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chart-bar__graph"},[_c('canvas',{ref:"canvas"}),_vm._v(" "),_c('ui-chart-tooltip',_vm._b({ref:"tooltip"},'ui-chart-tooltip',_vm.tooltip,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }